import React from 'react'
import PropTypes from 'prop-types'
import { RankUpButton } from 'src/components/house/RankUpButton'

export const HouseRightMenu = ({
  menuItems,
  onMenuItemClick,
  setIsRankUpModalOpen,
  showRankUpButton = true
}) => {
  const items = showRankUpButton ? [{ id: 'rank-up' }, ...menuItems] : menuItems

  return (
    <div className="absolute w-full px-4 z-50 bottom-8 xs:bottom-6">
      <div className="flex items-end justify-around gap-1">
        {items.map((item) => (
          <div key={item.id} className="flex-1 flex justify-center">
            {item.id === 'rank-up' ? (
              <RankUpButton onClick={() => setIsRankUpModalOpen(true)} />
            ) : (
              <button
                type="button"
                onClick={() => onMenuItemClick(item.id)}
                className="flex max-w-[5.5rem] items-center justify-center cursor-pointer hover:scale-105 transition-transform"
              >
                <img src={item.icon} alt={item.label} className="w-full h-full object-contain" />
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

HouseRightMenu.propTypes = {
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.any.isRequired
    })
  ).isRequired,
  onMenuItemClick: PropTypes.func.isRequired,
  setIsRankUpModalOpen: PropTypes.func.isRequired,
  showRankUpButton: PropTypes.bool
}
